module.exports = __webpack_public_path__ + "static/media/fa-regular-400.ba2a91dc.svg";